import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import NativeCloudPhoneView from '../views/NativeCloudPhoneView.vue'
import NativeCloudPhonePreviewFrameView from '../views/NativeCloudPhonePreviewFrameView.vue'
import NativeDeviceListView from '../views/NativeDeviceListView.vue'
import { fetchCurrentUser } from '../api/auth'
import { getToken, updateSessionUser } from '../utils/authSession'
import { prefersWebEntry } from '../utils/entryPreference'

let confirmedToken = null

function confirmStoredToken(token) {
  if (!token || confirmedToken === token) return

  confirmedToken = token
  void fetchCurrentUser()
    .then(updateSessionUser)
    .catch(() => {
      if (confirmedToken === token) {
        confirmedToken = null
      }
    })
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'entry',
      alias: '/download',
      component: () => import('../views/EntryView.vue'),
      meta: { public: true },
      beforeEnter: () => {
        if (getToken()) {
          return '/devices'
        }

        return prefersWebEntry() ? '/login' : true
      }
    },
    { path: '/login', name: 'login', component: LoginView },
    { path: '/legal/:document', name: 'legal', component: () => import('../views/LegalDocumentView.vue'), meta: { public: true } },
    { path: '/profile', name: 'profile', component: () => import('../views/ProfileView.vue') },
    { path: '/devices', name: 'native-device-list', component: NativeDeviceListView },
    {
      path: '/devices/:deviceId',
      name: 'native-cloud-phone',
      component: NativeCloudPhoneView,
      props: true
    },
    {
      path: '/preview/:deviceId',
      name: 'native-cloud-phone-preview',
      component: NativeCloudPhonePreviewFrameView,
      props: true
    },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
})

router.beforeEach((to) => {
  const token = getToken()
  const hasToken = Boolean(token)

  if (hasToken) {
    confirmStoredToken(token)
  }

  if (to.path !== '/login' && !to.meta.public && !hasToken) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  if (to.path === '/login' && hasToken) {
    return '/devices'
  }

  return true
})

export default router
